import parseApiDateImport from './parseApiDate';

export const parseApiDate = parseApiDateImport;
